
export default function WhoWeAre() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="who-we-are" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-0.5 bg-[#E8740C]"></div>
              <span className="text-[#E8740C] text-xs font-semibold tracking-[0.2em] font-heading uppercase">About Our Company</span>
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight mb-6">
              THE WELDING CONTRACTOR<br />
              <span className="text-[#E8740C]">CONTRACTORS TRUST</span>
            </h2>
            <p className="text-[#4A4A4A] text-sm leading-relaxed mb-5 font-body">
              New Generation Welding &amp; Fabrication is a full-service <strong>welding contractor</strong> based in the foothills of <strong>Yuba County, California</strong>. We deliver contractor-grade structural steel welding, custom metal fabrication, AG equipment builds, and heavy equipment repair — on time and on budget.
            </p>
            <p className="text-[#4A4A4A] text-sm leading-relaxed mb-8 font-body">
              Whether you need precision CNC plasma cutting for a commercial build-out or emergency mobile welding repair on a remote job site, our experienced team handles projects of every scale across <strong>Northern California and Southern California</strong>.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
                'Structural Steel Welding',
                'Custom Metal Fabrication',
                'Mobile Welding Repair',
                'Heavy Equipment Repair',
                'CNC Plasma Cutting',
                'Licensed & Insured',
              ].map((item) => (
                <div key={item} className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-[#E8740C] text-sm"></i>
                  </div>
                  <span className="text-[#1A1A1A] text-xs font-medium">{item}</span>
                </div>
              ))}
            </div>

            <a
              href="#request-quote"
              onClick={(e) => { e.preventDefault(); scrollToSection('request-quote'); }}
              className="inline-block bg-[#E8740C] text-white font-heading font-bold text-sm tracking-wider px-8 py-3.5 rounded-md hover:bg-[#d16a0b] transition-colors cursor-pointer whitespace-nowrap"
            >
              REQUEST A QUOTE
            </a>
          </div>

          <div className="relative">
            <div className="w-full h-[560px] rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://static.wixstatic.com/media/163680_c838403bb615489caedfe92c1b4301dc~mv2.jpg/v1/fill/w_302,h_402,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_5023.jpg"
                alt="Professional welding contractor performing structural steel fabrication work"
                title="New Generation Welding - Custom Metal Fabrication"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#E8740C] text-white p-6 rounded-lg shadow-xl">
              <p className="font-heading font-bold text-3xl">500+</p>
              <p className="text-xs tracking-wider mt-1">PROJECTS DELIVERED</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
